import {
    Swiper,
    Navigation,
    // Autoplay,
    // Scrollbar,
} from 'swiper';

Swiper.use(Navigation);
// Swiper.use(Autoplay);
// Swiper.use(Scrollbar);

const navigation = (el) => {
    const swiperClass = {
        nextEl: '.' + el + '-swiper__button--next',
        prevEl: '.' + el + '-swiper__button--prev',
    }
    return swiperClass;
}

let swiper;

$(window).on('load', function () {
    if($('.dealers__swiper').length) {
        swiper = new Swiper('.dealers__swiper', {
            spaceBetween: 60,
            breakpoints: {
                992: {
                    slidesPerView: 6,
                },
                768: {
                    slidesPerView: 4,
                },
                0: {
                    slidesPerView: 2,
                },
            },
            navigation: navigation('dealers__nav'),
        });
    }
});

$(window).on('resize', function () {
    if (swiper) {
        swiper.update();
    }
});
